import React from 'react';
import { Box, Typography, IconButton, useTheme } from '@mui/material';
import { KeyboardArrowUp } from '@mui/icons-material';
import { motion } from 'motion/react';
import { Step, useStep } from '../../../state/map';
import { setStep } from '../../../state/map';
import StepIndicator from './StepIndicator';
import { useAppDispatch } from '@/state/types';

interface BottomStepperBarProps {
  onExpandMenu: () => void;
}

const stepOrder = [Step.Location, Step.Pins, Step.Style, Step.Size];

const BottomStepperBar: React.FC<BottomStepperBarProps> = ({ onExpandMenu }) => {
  const theme = useTheme();
  const currentStep = useStep();
  const dispatch = useAppDispatch();

  const handleStepClick = (step: Step) => {
    dispatch(setStep(step));
  };

  return (
    <Box
      component={motion.div}
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.divider}`,
        zIndex: (theme) => theme.zIndex.drawer,
        padding: '16px',
        paddingBottom: '24px', // Extra padding for safe area
      }}
    >
      {/* Expand Menu CTA */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '12px',
          cursor: 'pointer'
        }}
        onClick={onExpandMenu}
      >
        <IconButton
          size="small"
          sx={{
            backgroundColor: theme.palette.action.hover,
            marginRight: '8px',
            '&:hover': {
              backgroundColor: theme.palette.action.selected,
            }
          }}
        >
          <KeyboardArrowUp />
        </IconButton>
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            fontSize: '12px',
            fontWeight: 500
          }}
        >
          Expand Menu
        </Typography>
      </Box>

      {/* Step Navigation */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        {stepOrder.map((step, index) => (
          <StepIndicator
            key={step}
            step={step}
            stepNumber={index + 1}
            isActive={currentStep === step}
            onClick={() => handleStepClick(step)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default BottomStepperBar;
